export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';

export const LOAD_COLLECTIONS_SUCCESS = 'LOAD_COLLECTIONS_SUCCESS';
export const LOAD_COLLECTION_SUCCESS = 'LOAD_COLLECTION_SUCCESS';

export const LOAD_RECIPES_SUCCESS = 'LOAD_RECIPES_SUCCESS';
export const LOAD_RECIPE_SUCCESS = 'LOAD_RECIPE_SUCCESS';


/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/